import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles.css'
import App from './App'
import { DeviceNotice } from './components/DeviceNotice'
import { ErrorBoundary } from './components/ErrorBoundary'
import { isBlockedDevice } from './lib/device'

const russian = navigator.language?.toLowerCase().startsWith('ru') ?? false
const root = createRoot(document.getElementById('root')!)

root.render(
  isBlockedDevice(navigator.userAgent) ? (
    <DeviceNotice locale={russian ? 'ru' : 'en'} />
  ) : (
    <StrictMode>
      <ErrorBoundary locale={russian ? 'ru' : 'en'}>
        <App />
      </ErrorBoundary>
    </StrictMode>
  ),
)
